import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  form {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    .details-container {
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 669px;
      min-width: 0;
      flex: 1;
      padding: 24px 16px 16px 0;

      .form-title {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
        margin: 0;
      }
    }

    .entity-picker {
      display: flex;
      gap: 16px;
      align-items: center;
      justify-content: space-between;
      padding: 16px;
      border: 1px dashed ${(props) => props.theme.colors.outline};
      border-radius: 12px;

      
      &.selected {
        border: 1px solid ${(props) => props.theme.colors.outline};
      }
      
      &:hover {
        border-color: ${(props) => props.theme.colors.white};
      }

      .text {
        flex-grow: 1;
        color: ${(props) => props.theme.colors.inactive};
      }

      .entity-info {
        display: flex;
        flex-direction: column;
        gap: 16px;
        /* justify-content: space-between; */
        flex-grow: 1;
        .title {
          /* flex-grow: 1; */
          font-size: 16px;
          color: ${(props) => props.theme.colors.text};
        }

        .subtitle {
          /* flex-grow: 1; */
        }
      }

      img {
        width: 80px;
        height: 80px;
        border-radius: 12px;
      }
    }

    .map-container {
      width: 351px;
      flex-shrink: 0;
      padding: 24px 0 16px 16px;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .map-card {
        flex: 1;
        min-height: 280px;
        max-height: 420px;
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;

        .map-wrapper {
          flex: 1;
          min-height: 0;
          height: auto;
        }

        .map-container {
          width: 100%;
          height: 100%;
          border-radius: 12px;
        }
      }
    }

    input[type="radio"]{
      display:none;
    }

    label {
      display: inline-flex;
      gap: 8px;
    }

    .checkbox {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin: 0 4px -4px 0; 
      position: relative;

      &:before {
        transition: all .3s ease-in-out;
        content: "";
        position: absolute;
        z-index: 1;
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid ${(props) => props.theme.colors.inactive};
      }
      
      &:after {
        transition: all .3s ease-in-out;
        content: "";
        position: absolute;
        width: 16px;
        height: 16px;
        background: transparent;
        z-index: 0;
        border: none;
      }
    }

    input[type="radio"] + label .checkbox {
      &:before,
      &:after {
        border-radius: 50%;
      }
    }

    input[type="radio"]:checked + label .checkbox{
      &:after {
        width: 16px;
        height: 16px;
        background: ${(props) => props.theme.colors.main_cta};
        transition: all .2s ease-in;
      }
    }

    input[type="radio"]:checked + label .checkbox{
      &:before {
        left: 5px;
        top: 2px;
        width: 6px;
        height: 11px;
        border: solid ${(props) => props.theme.colors.inactive};
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
  }

  @media (max-height: 820px) {
    form {
      .details-container {
        gap: 10px;
        padding: 12px 16px 8px 0;
      }

      .entity-picker {
        padding: 10px 12px;
        gap: 12px;

        img {
          width: 56px;
          height: 56px;
        }

        .entity-info {
          gap: 8px;
        }
      }

      .map-container {
        padding: 12px 0 8px 12px;

        .map-card {
          min-height: 180px;
          max-height: 240px;
          padding: 12px;
        }
      }
    }
  }

  .time-range {
    padding-top: 10px;

    .timeline-error {
      margin: 0 0 12px;
      color: ${(props) => props.theme.colors.red};
      font-family: ManropeLight, sans-serif;
      font-size: 13px;
      line-height: 1.5;
      text-align: left;
      max-width: 100%;
      white-space: pre-wrap;
      overflow-wrap: anywhere;
      word-break: break-word;
    }

    .scale {
      background: ${(props) => props.theme.colors.outline};
      border-radius: 12px;
      width: 100%;
      height: 24px;
    }
    .legend {
      margin-top: 16px;
      display: flex;
      justify-content: space-between;

      .label {
        width: 36px;
        font-size: 13px;
      }
    }
  }
`;

const FormBody = styled.div`
  display: flex;
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background_dashboard};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.inactive};
    border-radius: 4px;
  }
`;

const FormFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex-shrink: 0;
  padding: 16px 0 8px;
  margin-top: 8px;
  border-top: 1px solid ${(props) => props.theme.colors.outline};
`;

const FormFooterActions = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 16px;

  button {
    width: 150px;
    padding: 16px 30px;
    justify-content: center;
  }

  .request-button {
    background-color: ${(props) => props.theme.colors.main_cta};
    color: ${(props) => props.theme.colors.widget_background};

    &:hover:not(:disabled) {
      background-color: ${(props) => props.theme.colors.widget_hover_background};
      color: ${(props) => props.theme.colors.main_cta};
    }

    &:disabled {
      cursor: default;
      background-color: ${(props) => props.theme.colors.inactive};
      color: ${(props) => props.theme.colors.black};
    }
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;
`;

const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  min-width: 0;
  max-height: min(120px, 18vh);
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 4px;

  @media (max-height: 820px) {
    max-height: min(96px, 14vh);
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.background_dashboard};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.inactive};
    border-radius: 4px;
  }
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: left;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  max-width: 100%;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

const InfoMessage = styled.p`
  color: ${(props) => props.theme.colors.main_cta};
  text-align: left;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  max-width: 100%;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

const TimeRangeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`;

const OfflineTimelineSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  border-radius: 12px;
  background: ${(props) => props.theme.colors.background_dashboard};
  border: 1px solid ${(props) => props.theme.colors.outline};
  border-left: 4px solid ${(props) => props.theme.colors.orange};
`;

const OfflineStatusTitle = styled.p`
  margin: 0;
  font-family: ManropeBold, sans-serif;
  font-size: 14px;
  color: ${(props) => props.theme.colors.orange};
`;

const OfflineStatusMessage = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.text};
  text-align: left;
  font-family: ManropeLight, sans-serif;
  font-size: 13px;
  line-height: 1.5;
  opacity: 0.85;
`;

export default {
  Wrapper,
  FormBody,
  FormFooter,
  FormFooterActions,
  RowContainer,
  ErrorMessage,
  InfoMessage,
  MessagesContainer,
  TimeRangeSection,
  OfflineTimelineSection,
  OfflineStatusTitle,
  OfflineStatusMessage,
};
